import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography } from '@mui/material';
import { MoreVert as MoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";

const PostCategoriesTableRow = ({
    item,
    index,
    page,
    perPage,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { i18n } = useTranslation();
    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onChange={(event) => onRowCheckboxClick(event, item.id)}
                />
            </TableCell>

            <TableCell>{index + 1 + (page - 1) * perPage}</TableCell>

            <TableCell align="left">
                <Typography variant="body2">{item.name?.en || '-'}</Typography>
            </TableCell>

            <TableCell align="right">
                <Typography variant="body2">{item.name?.ar || '-'}</Typography>
            </TableCell>

            <TableCell align="center">
                <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>{item.slug}</Typography>
            </TableCell>

            <TableCell align="center">
                <Typography variant="body2">{item.parent?.name?.[i18n.language] || '-'}</Typography>
            </TableCell>

            <TableCell align="center">
                {dayjs(item.created_at).format("YYYY-MM-DD")}
            </TableCell>

            <TableCell align="center">
                <IconButton onClick={(e) => onMenuOpen(e, item)}>
                    <MoreIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default PostCategoriesTableRow;
